import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import SvgIcon from './SvgIcon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// TODO: Get this icon to fill with currentColor - not default to white
var FullscreenInvertedIcon = function FullscreenInvertedIcon(props) {
  return /*#__PURE__*/_jsx(SvgIcon, _objectSpread(_objectSpread({}, props), {}, {
    viewBox: "0 0 18 18",
    children: /*#__PURE__*/_jsx("g", {
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/_jsx("g", {
        children: /*#__PURE__*/_jsx("g", {
          children: /*#__PURE__*/_jsx("g", {
            transform: "translate(-870 -69) translate(858 51) translate(0 12)",
            children: /*#__PURE__*/_jsxs("g", {
              children: [/*#__PURE__*/_jsx("path", {
                d: "M0 0L18 0 18 18 0 18z",
                transform: "translate(12 6)"
              }), /*#__PURE__*/_jsx("path", {
                fill: "#FFFFFF",
                d: "M15.25 2.25c1.105 0 2 .895 2 2v9.5c0 1.105-.895 2-2 2H2.75c-1.105 0-2-.895-2-2v-9.5c0-1.105.895-2 2-2h12.5zm.5 1.5H2.25v10.5h13.5V3.75zm-1.5 1.5v7.5H3.75v-7.5h10.5z",
                transform: "translate(12 6)"
              })]
            })
          })
        })
      })
    })
  }));
};
export default FullscreenInvertedIcon;